import { Controller } from "@hotwired/stimulus";
import { createRoot } from "react-dom/client";
import { Suspense } from "react";
import RoleAssignmentsForm from "../../components/administration/RoleAssignmentsForm";
import queryClient from "../../helpers/queryClient";
import { QueryClientProvider } from "react-query";

// Connects to data-controller="administration--role-assignments"
export default class extends Controller {
  connect() {
    this.root = createRoot(this.element);
    this.root.render(
      <QueryClientProvider client={queryClient}>
        <Suspense fallback={null}>
          <RoleAssignmentsForm />
        </Suspense>
      </QueryClientProvider>,
    );
  }

  disconnect() {
    if (this.root) {
      this.root.unmount();
    }
  }
}
